module.exports = __webpack_public_path__ + "img/media-7.0595f0bb.jpg";